/* ==========================================================================
   Reseñas de Okendo - Variante 2: las piezas que el editor no ofrece
   María Catalá Beauty

   El editor de Okendo no tiene interruptor para nada de esto (comprobado el
   2026-09-08 volcando todas sus opciones), y la piel se hace en
   assets/okendo-resenas.css. Aquí van solo las tres piezas que hay que añadir:

     1. El botón "Ver las N con foto" al lado de "Filtros".
     2. El rótulo "N fotos de clientas" encima del carrusel.
     3. La nota de "generado con IA", que Okendo esconde en un tooltip, movida
        a la vista debajo del resumen.

   No pide nada por red: todo sale del JSON que Okendo ya deja en la página
   (<script data-oke-metafield-data>). Si algo no está donde se espera, la
   función se calla y no rompe nada: el widget sigue funcionando igual.
   ========================================================================== */
(function () {
  'use strict';

  var MARCA = 'data-mcb-resenas';

  // Marcador de diagnostico: permite ver desde fuera si este fichero llega a
  // ejecutarse y hasta donde. No hace nada mas.
  var HUELLA = (window.__mcbResenas = { version: 4, arranques: 0, aplicaciones: 0, ultimo: null });

  function leerDatos() {
    try {
      var s = document.querySelector('script[data-oke-metafield-data]');
      // el de la ficha lleva las reseñas; el del resumen de estrellas es corto
      var todos = document.querySelectorAll('script[data-oke-metafield-data]');
      for (var i = 0; i < todos.length; i++) {
        var t = (todos[i].textContent || '').trim();
        if (t.length < 200) continue;
        var j = JSON.parse(t);
        if (j && (j.media || j.reviews)) return j;
      }
      return s ? JSON.parse(s.textContent) : null;
    } catch (e) {
      return null;
    }
  }

  function cuantasFotos(datos) {
    if (datos && Array.isArray(datos.media) && datos.media.length) return datos.media.length;
    var n = document.querySelectorAll('.oke-w .oke-mediaCarousel-slide').length;
    return n || 0;
  }

  /* Estado del boton de fotos. Vive aqui fuera y no en el DOM porque Okendo
     rehace la barra entera al ordenar y se llevaria el boton por delante. */
  var MODO = { fotos: false, ordenPrevio: null };

  var ICONO_FOTO = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">'
    + '<path d="M5.5 1h5l1 2H15v11H1V3h3.5zM8 11.5A3 3 0 108 5.5a3 3 0 000 6z"/></svg>';
  var ICONO_TODAS = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">'
    + '<path d="M1 2h14v2H1zM1 7h14v2H1zM1 12h14v2H1z"/></svg>';

  function pintarBoton(boton, n) {
    boton.innerHTML = MODO.fotos ? ICONO_TODAS : ICONO_FOTO;
    boton.appendChild(document.createTextNode(MODO.fotos
      ? 'Ver todas las reseñas'
      : (n === 1 ? 'Ver la que tiene foto' : 'Ver las ' + n + ' con foto')));
    boton.setAttribute('aria-pressed', MODO.fotos ? 'true' : 'false');
  }

  /* --- 1. Botón "Ver las N con foto" ------------------------------------
     No filtra por su cuenta: reutiliza la propia ordenación de Okendo
     ("Fotos y vídeos"), que sube las reseñas con foto arriba del todo. */
  function botonConFoto(datos) {
    var cabecera = document.querySelector('.oke-w .oke-w-reviews-head');
    if (!cabecera || cabecera.querySelector('[' + MARCA + '="foto"]')) return;

    var select = document.querySelector('.oke-w .oke-sortSelect-sort');
    if (!select) return;
    var opcion = null;
    for (var i = 0; i < select.options.length; i++) {
      // Solo ASCII a proposito: Shopify minifica este fichero y le destroza
      // los bytes no ASCII ("vídeo" salia servido como "v?deo"). "Fotos y vídeos"
      // encaja igual con "foto".
      if (/foto|photo|video/i.test(select.options[i].text)) { opcion = select.options[i]; break; }
    }
    if (!opcion) return;

    var n = cuantasFotos(datos);
    if (!n) return;

    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'oke-button mcb-verConFoto';
    boton.setAttribute(MARCA, 'foto');
    pintarBoton(boton, n);

    boton.addEventListener('click', function () {
      var volver = MODO.fotos;
      // al entrar en "solo con foto" se guarda como estaba, para poder volver
      if (!volver) MODO.ordenPrevio = select.value;
      var destino = volver ? (MODO.ordenPrevio || select.options[0].value) : opcion.value;
      MODO.fotos = !volver;
      select.value = destino;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      pintarBoton(boton, n);
      var lista = document.querySelector('.oke-w .oke-w-reviews-main');
      if (lista && lista.scrollIntoView) lista.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* Si se cambia la ordenacion a mano, el boton deja de estar "activo": si no,
       se quedaria diciendo "Ver todas las resenas" con otra ordenacion puesta. */
    if (!select.getAttribute(MARCA)) {
      select.setAttribute(MARCA, 'vigilado');
      select.addEventListener('change', function () {
        if (select.value !== opcion.value && MODO.fotos) {
          MODO.fotos = false;
          var b = document.querySelector('.mcb-verConFoto');
          if (b) pintarBoton(b, n);
        }
      });
    }

    /* Justo detras del boton de Filtros, como en la referencia. Ojo: el
       filterToggle no siempre cuelga directamente de la cabecera, asi que hay
       que subir hasta el hijo directo antes de colocarse detras. Sin esto se
       caia al `else` y el boton salia el PRIMERO, delante de Filtros. */
    var filtros = cabecera.querySelector('.oke-w-reviews-filterToggle');
    var refer = filtros;
    while (refer && refer.parentNode && refer.parentNode !== cabecera) refer = refer.parentNode;
    if (refer && refer.parentNode === cabecera) cabecera.insertBefore(boton, refer.nextSibling);
    else cabecera.insertBefore(boton, cabecera.firstChild);
  }

  /* --- 2. Rótulo "N fotos de clientas" sobre el carrusel ----------------- */
  function rotuloFotos(datos) {
    var modulo = document.querySelector('.oke-w .oke-w-mediaCarouselModule');
    if (!modulo || modulo.querySelector('[' + MARCA + '="rotulo"]')) return;
    var n = cuantasFotos(datos);
    if (!n) return;

    var rotulo = document.createElement('div');
    rotulo.className = 'mcb-rotuloFotos';
    rotulo.setAttribute(MARCA, 'rotulo');

    var texto = document.createElement('span');
    texto.className = 'mcb-rotuloFotos-texto';
    texto.textContent = n === 1 ? '1 foto de clientas' : n + ' fotos de clientas';
    rotulo.appendChild(texto);

    /* Las flechas del carrusel van encima de las fotos y tapaban la ultima. En
       la referencia viven en la fila del rotulo, a la derecha. Se MUEVEN (no se
       clonan) para no perder lo que Okendo les tiene enganchado. */
    var flechas = document.createElement('div');
    flechas.className = 'mcb-flechas';
    var prev = modulo.querySelector('.oke-mediaCarousel-prev');
    var next = modulo.querySelector('.oke-mediaCarousel-next');
    if (prev) flechas.appendChild(prev);
    if (next) flechas.appendChild(next);
    if (flechas.children.length) rotulo.appendChild(flechas);

    modulo.insertBefore(rotulo, modulo.firstChild);
  }

  /* --- 3. La nota del resumen, fuera del tooltip -------------------------
     Okendo mete "Generado por IA a partir de las N reseñas más recientes" en
     un tooltip que solo se ve al pasar por encima. La referencia la enseña
     siempre, debajo del texto. Se mueve el nodo, no se copia, para no repetir
     el texto si Okendo lo cambia. */
  function notaIA() {
    var resumen = document.querySelector('.oke-w .oke-reviewsSummary');
    if (!resumen || resumen.querySelector('[' + MARCA + '="nota"]')) return;
    var contenido = resumen.querySelector('.oke-reviewsSummary-heading .oke-tooltip-content');
    if (!contenido) return;

    var nota = document.createElement('div');
    nota.className = 'mcb-notaIA';
    nota.setAttribute(MARCA, 'nota');
    // solo la primera línea: la segunda es "última actualización", que no aporta
    var primera = contenido.querySelector('div');
    /* Okendo escribe "Generado por IA ... de clientes"; la referencia lo dice
       "Generado con IA ...". Se limpia sin inventar nada: solo la preposicion
       y la coletilla del final. */
    var texto = ((primera || contenido).textContent || '').trim()
      .replace(/por\s+IA/i, 'con IA')
      .replace(/\s+de\s+clientes\s*$/i, '')
      .replace(/\s+de\s*$/i, '');
    nota.textContent = texto;
    if (!nota.textContent) return;
    resumen.appendChild(nota);
  }

  /* --- 4. Sello "La recomiendo" en el panel de cada clienta --------------
     Okendo NO lo pinta con la plantilla `split` y no hay interruptor para
     ello, pero el dato (`isRecommended`) ya viaja en el JSON de la pagina,
     asi que no hace falta pedir nada por red.

     LIMITE CONOCIDO: ese JSON solo trae la primera tanda de resenas (5). Las
     que se cargan al pulsar "Mostrar mas" no salen ahi, y esas se quedan sin
     sello. Se prefiere eso a inventarselo o a meter una llamada extra a la
     API en cada visita a la ficha.

     El emparejamiento se hace por nombre + principio del texto, porque el DOM
     no expone el id de la resena. */
  function normalizar(t) {
    return (t || '').replace(/\s+/g, ' ').trim().toLowerCase().slice(0, 60);
  }

  /* Mapa de "quien dijo que" -> recomienda. Se va llenando con lo que llega:
     primero el JSON de la pagina y luego lo que Okendo se va trayendo al
     ordenar, filtrar o pulsar "Mostrar mas". */
  var RECOMIENDA = {};

  function tragarResenas(lista) {
    if (!lista || !lista.length) return false;
    var nuevos = false;
    for (var i = 0; i < lista.length; i++) {
      var r = lista[i];
      if (!r || r.isRecommended !== true) continue;
      var quien = normalizar((r.reviewer || {}).displayName);
      var a = quien + '||' + normalizar(r.body);
      var b = quien + '||' + normalizar(r.title);
      if (!RECOMIENDA[a] || !RECOMIENDA[b]) nuevos = true;
      RECOMIENDA[a] = true;
      RECOMIENDA[b] = true;
    }
    return nuevos;
  }

  /* Okendo pide sus resenas a api.okendo.io. Desde el dominio de la tienda esa
     API no se puede llamar a pelo (da CORS), asi que no vale con pedirlas por
     nuestra cuenta. Lo que si se puede es mirar de reojo las respuestas que ya
     recibe Okendo: se envuelve `fetch`, se deja pasar SIEMPRE tal cual, y solo
     se lee una copia de la respuesta. Si algo falla, se traga el error y la
     pagina sigue igual. Sin esto el sello desaparecia de todas las resenas en
     cuanto se ordenaba o se cargaban mas. */
  function escucharPeticiones() {
    if (window.__mcbFetchEnvuelto || typeof window.fetch !== 'function') return;
    window.__mcbFetchEnvuelto = true;
    var original = window.fetch;
    window.fetch = function () {
      var promesa = original.apply(this, arguments);
      try {
        var a0 = arguments[0];
        var url = String((a0 && a0.url) || a0 || '');
        if (/okendo\.io\/[^?]*reviews/i.test(url)) {
          promesa.then(function (res) {
            try {
              res.clone().json().then(function (d) {
                if (tragarResenas(d && d.reviews)) setTimeout(aplicar, 60);
              })['catch'](function () { });
            } catch (e) { }
          })['catch'](function () { });
        }
      } catch (e) { }
      return promesa;
    };
  }

  function selloRecomienda(datos) {
    if (datos && Array.isArray(datos.reviews)) tragarResenas(datos.reviews);
    var mapa = RECOMIENDA;

    var resenas = document.querySelectorAll('.oke-w .oke-w-reviewSplit');
    for (var k = 0; k < resenas.length; k++) {
      var res = resenas[k];
      var panel = res.querySelector('.oke-w-reviewSplit-reviewer');
      if (!panel || panel.querySelector('[' + MARCA + '="recomienda"]')) continue;

      var nombre = normalizar((res.querySelector('.oke-w-reviewer-name') || {}).textContent);
      var cuerpo = normalizar((res.querySelector('.oke-reviewContent-body') || {}).textContent);
      var titulo = normalizar((res.querySelector('.oke-reviewContent-title') || {}).textContent);
      if (!mapa[nombre + '||' + cuerpo] && !mapa[nombre + '||' + titulo]) continue;

      var sello = document.createElement('span');
      sello.className = 'mcb-recomienda';
      sello.setAttribute(MARCA, 'recomienda');
      sello.innerHTML = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">'
        + '<path d="M6.5 14H3V6.5h2L7.5 2c.9 0 1.6.8 1.4 1.7L8.4 6.5h4.1c.9 0 1.6.9 1.4 1.8'
        + 'l-1 4.4c-.1.8-.8 1.3-1.6 1.3z"/></svg>';
      sello.appendChild(document.createTextNode('La recomiendo'));
      panel.appendChild(sello);
    }
  }

  /* --- 5. Textos, para que digan lo mismo que la referencia ---------------
     Okendo no tiene pantalla de traducciones (comprobado: en Settings solo hay
     User, Usage, Billing, Plan, Early Access, Mail, Integrations,
     Import/Export, Custom CSS, Q&A y Rewards), asi que se cambian aqui.

     Se cambia SOLO lo que se ve. No se toca ni el cuestionario de Okendo ni el
     dato guardado: las etiquetas de atributo siguen siendo "Profesional del
     maquillaje" y "Nuestra fibra sintetica" en la ficha del atributo y en lo
     que se le pregunta a la clienta; aqui se muestran cortas porque es lo que
     cabe en el panel de 300px sin partirse en dos lineas.

     Cada cambio solo se aplica si el texto actual es el que esperamos, asi que
     si Okendo cambia su literal, esto se aparta y no pisa nada. */
  var TEXTOS = [
    { donde: '.oke-w-reviewer-verified', de: /^comprador verificado$/i, a: 'Compra verificada' },
    { donde: '.oke-helpful-label', de: /^.?fue util esto\?$/i, a: '¿Te ha servido?' },
    { donde: '.oke-w-selectAttr-item-title', de: /^profesional del maquillaje$/i, a: 'Profesional' },
    { donde: '.oke-w-selectAttr-item-title', de: /^nuestra fibra sint.tica$/i, a: 'Fibra sintética' },
    { donde: '.oke-w-reviewReply-title', de: /^maria catala beauty$/i, a: 'María Catalá Beauty' },
    { donde: '.oke-reviewsSummary-heading-text', de: /^resumen de rese.as$/i, a: 'Resumen de las reseñas' }
  ];

  function sinTildes(t) {
    return (t || '').normalize ? (t || '').normalize('NFD').replace(/[̀-ͯ]/g, '') : (t || '');
  }

  function ajustarTextos() {
    for (var i = 0; i < TEXTOS.length; i++) {
      var regla = TEXTOS[i];
      var nodos = document.querySelectorAll('.oke-w ' + regla.donde);
      for (var k = 0; k < nodos.length; k++) {
        var el = nodos[k];
        if (el.getAttribute(MARCA) === 'texto') continue;
        // solo el texto propio: no se tocan iconos ni hijos
        var propio = null;
        for (var n = 0; n < el.childNodes.length; n++) {
          if (el.childNodes[n].nodeType === 3 && el.childNodes[n].textContent.trim()) { propio = el.childNodes[n]; break; }
        }
        if (!propio) continue;
        var actual = propio.textContent.trim();
        if (!regla.de.test(actual) && !regla.de.test(sinTildes(actual))) continue;
        propio.textContent = regla.a;
        el.setAttribute(MARCA, 'texto');
      }
    }
  }

  /* --- 6. Reagrupar la tarjeta como la referencia -----------------------
     La plantilla `split` de Okendo son TRES columnas sueltas (resenador /
     cuerpo / atributos) y no se pueden juntar solo con CSS: al colocarlas en
     una rejilla, la altura de la primera fila la manda la pieza mas alta de
     CUALQUIER columna, asi que el panel crema empujaba el titulo hacia abajo y
     quedaba un hueco enorme entre las estrellas y el titulo.

     Aqui se rehace la estructura de la referencia, que es simple: un `o-side`
     (el panel) y un `o-main` (todo lo demas), con las estrellas y la fecha en
     su propia fila arriba. No se crea ni se borra contenido: solo se mueven
     los nodos que ya pinta Okendo, asi que si esto fallara la resena seguiria
     viendose entera, solo que con el reparto de Okendo. */
  function reagrupar() {
    var principales = document.querySelectorAll('.oke-w .oke-w-reviewSplit-main');
    for (var i = 0; i < principales.length; i++) {
      var main = principales[i];
      if (main.getAttribute(MARCA) === 'reagrupado') continue;

      /* OJO: el resenador, las estrellas y la fecha NO son hijos directos de
         `-main`: cuelgan de `-left`, que es `display:contents` y por eso
         PARECEN hijos en la rejilla sin serlo en el DOM. Buscandolos con
         `:scope >` no se encontraba ninguno y esto no hacia nada. */
      var panel = main.querySelector('.oke-w-reviewSplit-reviewer');
      var atributos = main.querySelector('.oke-w-reviewSplit-right');
      var estrellas = main.querySelector('.oke-w-reviewSplit-stars');
      var fecha = main.querySelector('.oke-w-reviewSplit-date');
      var cuerpo = main.querySelector('.oke-w-reviewSplit-mid');
      if (!panel || !cuerpo) continue;

      var lado = document.createElement('div');
      lado.className = 'mcb-side';
      panel.parentNode.insertBefore(lado, panel);
      lado.appendChild(panel);
      if (atributos) lado.appendChild(atributos);

      var principal = document.createElement('div');
      principal.className = 'mcb-main';
      main.appendChild(principal);

      if (estrellas || fecha) {
        var arriba = document.createElement('div');
        arriba.className = 'mcb-top';
        if (estrellas) arriba.appendChild(estrellas);
        if (fecha) arriba.appendChild(fecha);
        principal.appendChild(arriba);
      }
      principal.appendChild(cuerpo);

      /* La respuesta de la marca colgaba FUERA de la rejilla, asi que esperaba
         a que terminase el panel crema y caia 118px por debajo del texto. Va
         dentro de la columna del cuerpo, justo detras, como en la referencia. */
      var resena = main.parentNode;
      var respuesta = resena && resena.querySelector('.oke-w-reviewSplit-reply');
      if (respuesta) principal.appendChild(respuesta);

      /* En la referencia el orden es: texto, respuesta de la marca y al final
         "Te ha servido?". Okendo mete el pie dentro del cuerpo, asi que queda
         por delante de la respuesta; se saca al final. */
      var pie = principal.querySelector('.oke-w-reviewSplit-footer');
      if (pie) principal.appendChild(pie);

      main.setAttribute(MARCA, 'reagrupado');
    }
  }

  function aplicar() {
    HUELLA.aplicaciones++;
    var datos = leerDatos();
    HUELLA.ultimo = {
      hayW: !!document.querySelector('.oke-w'),
      hayCabecera: !!document.querySelector('.oke-w .oke-w-reviews-head'),
      hayDatos: !!datos,
      fotos: cuantasFotos(datos)
    };
    try { reagrupar(); } catch (e) { }
    try { botonConFoto(datos); } catch (e) { }
    try { rotuloFotos(datos); } catch (e) { }
    try { notaIA(); } catch (e) { }
    try { selloRecomienda(datos); } catch (e) { }
    try { ajustarTextos(); } catch (e) { }
  }

  /* El observador se cuelga del <body>, NO de `.oke-w`.

     Por qué: `.oke-w` ya existe vacío en cuanto carga la página, antes de que
     Okendo pinte nada. Colgando el observador de ahí pasaban dos cosas a la
     vez: se daba por arrancado sin haber nada que insertar, y al pintar, Okendo
     REEMPLAZA ese nodo, así que el observador se quedaba mirando un elemento
     desconectado y no volvía a saltar nunca. Resultado: el script cargaba, no
     daba ningún error, y no hacía absolutamente nada.

     Desde el <body> sobrevive a los repintados de Okendo, que son unos cuantos:
     al ordenar, al filtrar y al pulsar "Mostrar más". */
  function arrancar() {
    HUELLA.arranques++;
    if (!document.body) return false;
    aplicar();
    var pendiente = null;
    var observador = new MutationObserver(function () {
      if (pendiente) return;
      pendiente = setTimeout(function () { pendiente = null; aplicar(); }, 300);
    });
    observador.observe(document.body, { childList: true, subtree: true });
    return true;
  }

  /* El widget lo pinta el JS de Okendo bastante después de cargar la página,
     así que hay que esperarlo sondeando.

     OJO: aquí hubo un intento de "no sondear en páginas sin reseñas" mirando
     si existía `[data-oke-container]` al arrancar. No sirve: en ese momento
     Okendo no ha pintado nada todavía, ni en la propia ficha de producto, así
     que el guardarraíl se comía también el caso bueno. Se sondea siempre: son
     60 comprobaciones de un `querySelector` y se para solo a los 30 segundos. */
  function esperarAlWidget() {
    if (arrancar()) return;
    var intentos = 0;
    var reloj = setInterval(function () {
      intentos++;
      if (arrancar() || intentos > 60) clearInterval(reloj);
    }, 500);
  }

  escucharPeticiones();
  esperarAlWidget();
})();
